import HttpGlobal from "../Global/HttpGlobal.class";
import { customerApiBaseUrl, isNativeMode } from "../../../native/nativeMode";

export default class HttpCheckoutRepository extends HttpGlobal {
  private readonly API_URL_CHECKOUT:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/checkout`;

  private readonly API_URL:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api`;

  confirm = async ({ price, paymentMethod }: any) => {
    const response = await this.generalPost({
      url: `${this.API_URL_CHECKOUT}/signature/${this.leadId}`,
      dataRequest: { amount: price, method: paymentMethod },
    });

    return response;
  };

  finishRequest = async ({ price, paymentMethod }: any) => {
    const response = await this.generalPost({
      url: `${this.API_URL_CHECKOUT}/finish/${this.leadId}`,
      dataRequest: { amount: price, method: paymentMethod },
    });

    return response;
  };

  finishSigned = async () => {
    // Born-native: no-op en el gateway (la póliza nace por el evento de firma).
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${this.leadId}/contract-finish`
      : `${this.API_URL_CHECKOUT}/finish/${this.leadId}/signed`;
    const response = await this.generalPost({ url, dataRequest: {} });

    return response;
  };

  finishSucceed = async () => {
    const response = await this.generalPost({
      url: `${this.API_URL_CHECKOUT}/finish/${this.leadId}/succeeded`,
      dataRequest: {},
    });

    return response;
  };

  finishWaitingSignature = async () => {
    // Born-native: "firmar luego"; no-op en el gateway.
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${this.leadId}/contract-finish-waiting`
      : `${this.API_URL_CHECKOUT}/finish/${this.leadId}/waiting-signature`;
    const response = await this.generalPost({ url, dataRequest: {} });

    return response;
  };

  savePaymentMethod = async (data: any) => {
    // Organic native (F5d): first-sync del funnel (persiste el método tras el
    // SetupIntent; native-aware vía payment_lead_ref). El body del monolito no
    // aplica — el gateway resuelve el método del perfil del lead.
    if (isNativeMode()) {
      // El gateway responde {ok:true}; el caller (StripeContext.fetchSavePayment)
      // valida la cadena "OK" del monolito. Normalizamos al mismo contrato para
      // que el flujo avance tras el first-sync en vez de caer en el catch.
      const res = await this.generalPost({
        url: `${customerApiBaseUrl()}/customer/leads/${this.leadId}/payment/first-sync`,
        dataRequest: {},
      });
      return res?.ok === true ? "OK" : res;
    }
    const response = await this.generalPost({
      url: `${this.API_URL_CHECKOUT}/paymentmethod/save`,
      dataRequest: data,
    });

    return response;
  };

  saveStatus = async (status: string) => {
    const response = await this.generalPatch({
      url: `${this.API_URL}/lead/ensure-card-validation/${this.leadId}/${status}`,
      dataRequest: {},
    });

    return response;
  };

  acceptLegalNote = async () => {
    if (isNativeMode()) {
      // Alta NATIVE: aceptar la nota legal dispara la creación de la proposal
      // AGL en ms-agl (que arma el body native, POSTea a AGL y persiste el
      // numeroProposta). Sustituye al accept-legal-note del monolito.
      return this.generalPost({
        url: `${customerApiBaseUrl()}/customer/leads/${this.leadId}/proposal`,
        dataRequest: {},
      });
    }
    const response = await this.generalPost({
      url: `${this.API_URL_CHECKOUT}/accept-legal-note/${this.leadId}`,
      dataRequest: {}
    });

    return response;
  }

  isReadyToPaymentValidation = async () => {
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${this.leadId}/payment-ready`
      : `${this.API_URL}/is-ready-to-payment-validation-pending/${this.leadId}`;
    const response = await this.generalGet(url);

    return response;
  }

  ensureFundsFromCustomer = async () => {
    if (isNativeMode()) {
      // Born-native: cobro (validación €0,50 + 3DS) contra la banda native vía
      // gateway. returnUrl = la URL actual, para volver aquí tras el 3DS.
      const returnUrl =
        typeof window !== "undefined" ? window.location.href : "";
      return this.generalPost({
        url: `${customerApiBaseUrl()}/customer/leads/${this.leadId}/ensure-funds`,
        dataRequest: { returnUrl },
      });
    }
    const response = await this.generalGet(`${this.API_URL}/lead/ensure-funds-from-customer/${this.leadId}`);

    return response;
  }
}
